/**
 * PDP Size → Image Alt Sync
 * ----------------------------------------------------
 * Changes the active slide in the Swiper carousel based on
 * the selected size option. Looks for image alt tags containing
 * [toddler], [preschool], or [youth].
 * Runs only if the product title includes the word "kids".
 *
 * Source of truth for size selection: <select id="Option1" name="options[Size]">
 */

(function () {
  // -----------------------------
  //  CONFIGURATION
  // -----------------------------
  const SIZE_TOKENS = ['toddler', 'preschool', 'youth'];

  const SELECTORS = {
    desktopCarousel: '.swiper-main-desktop',
    mobileCarousel: '.swiper-main-mobile',
    sizeSelect: 'select#Option1[name="options[Size]"]',
    titleElements: [
      '.product-title',
      '.product__title',
      'h1.product-single__title',
      'meta[property="og:title"]',
    ],
  };

  const SLIDE_SPEED = 300;

  // -----------------------------
  //  HELPER FUNCTIONS
  // -----------------------------

  /** Checks if the product title includes the word "kids" */
  function isKidsProduct() {
    let titleText = '';

    for (const selector of SELECTORS.titleElements) {
      const element = document.querySelector(selector);
      if (element) {
        titleText = element.textContent || element.getAttribute('content') || '';
        break;
      }
    }

    if (!titleText && document.title) {
      titleText = document.title;
    }

    return titleText.toLowerCase().includes('kids');
  }

  /** Extracts the size token [toddler], [preschool], [youth] from an image alt */
  function getTokenFromAlt(altText) {
    const match = String(altText || '').toLowerCase().match(/\[(toddler|preschool|youth)\]/i);
    return match ? match[1] : null;
  }

  /** Normalizes text like "Toddler" → "toddler" */
  function normalizeSizeLabel(label) {
    return String(label || '').trim().toLowerCase();
  }

  /** Returns the active Swiper instance for a given selector */
  function getSwiperInstance(selector) {
    const element = document.querySelector(selector);
    return element && element.swiper ? element.swiper : null;
  }

  /** Builds a map { token: slideIndex } from image alt attributes */
  function buildImageMap(carouselSelector) {
    const root = document.querySelector(carouselSelector);
    if (!root) return {};

    const tokenToIndexMap = {};

    root.querySelectorAll('.swiper-slide img').forEach((img, index) => {
      const token = getTokenFromAlt(img.getAttribute('alt'));
      if (token && tokenToIndexMap[token] === undefined) {
        tokenToIndexMap[token] = index;
      }
    });

    // Current rule: preschool and youth use the same image if one is missing
    if (tokenToIndexMap.preschool !== undefined && tokenToIndexMap.youth === undefined) {
      tokenToIndexMap.youth = tokenToIndexMap.preschool;
    }
    if (tokenToIndexMap.youth !== undefined && tokenToIndexMap.preschool === undefined) {
      tokenToIndexMap.preschool = tokenToIndexMap.youth;
    }

    return tokenToIndexMap;
  }

  /** Slides the carousel if there’s a matching image for the selected size */
  function slideToImageIfExists(swiper, imageMap, sizeLabel) {
    if (!swiper || !imageMap) return;

    const key = normalizeSizeLabel(sizeLabel);
    if (!SIZE_TOKENS.includes(key)) return;

    const imageIndex = imageMap[key];
    if (typeof imageIndex === 'number') {
      swiper.slideTo(imageIndex, SLIDE_SPEED);
    }
  }

  // -----------------------------
  // MAIN FUNCTION
  // -----------------------------
  function initializeSizeToAltFeature() {
    if (!isKidsProduct()) return; // Only run for Kids products

    // Get initial Swiper instances and image maps
    let desktopSwiper = getSwiperInstance(SELECTORS.desktopCarousel);
    let mobileSwiper = getSwiperInstance(SELECTORS.mobileCarousel);

    let desktopImageMap = buildImageMap(SELECTORS.desktopCarousel);
    let mobileImageMap = buildImageMap(SELECTORS.mobileCarousel);

    /** Handles switching the image when a size is selected */
    function handleSizeChange(selectedSize) {
      if(!window.changingSize) return
      slideToImageIfExists(desktopSwiper, desktopImageMap, selectedSize);
      slideToImageIfExists(mobileSwiper, mobileImageMap, selectedSize);
    }

    // Helper: get current size from <select>
    function getCurrentSelectedSize() {
      const select = document.querySelector(SELECTORS.sizeSelect);
      if (!select) return null;
      const val = select.value || (select.selectedOptions && select.selectedOptions[0]?.value);
      return val || null;
    }

    // Initial sync on page load
    const initialSize = getCurrentSelectedSize();
    if (initialSize) handleSizeChange(initialSize);

    // Watch select changes
    const selectElement = document.querySelector(SELECTORS.sizeSelect);
    if (selectElement) {
      selectElement.addEventListener('change', () => {
        handleSizeChange(selectElement.value);
      });
    }

    // Rebuild maps if the gallery re-renders; then re-sync to the current size
    const observerConfig = { childList: true, subtree: true };

      [SELECTORS.desktopCarousel, SELECTORS.mobileCarousel].forEach(selector => {
      const node = document.querySelector(selector);
      if (!node) return;

      const observer = new MutationObserver(() => {
        desktopSwiper = getSwiperInstance(SELECTORS.desktopCarousel);
        mobileSwiper = getSwiperInstance(SELECTORS.mobileCarousel);
        desktopImageMap = buildImageMap(SELECTORS.desktopCarousel);
        mobileImageMap = buildImageMap(SELECTORS.mobileCarousel);

        const current = getCurrentSelectedSize();
        if (current) handleSizeChange(current);
      });

      observer.observe(node, observerConfig);
    });
  }

  // DOM ready guard (safe even if script is loaded with "defer")
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeSizeToAltFeature);
  } else {
    initializeSizeToAltFeature();
  }
})();

window.changingSize = false;
const sizeBtns = document.querySelectorAll('button[data-variant]');
sizeBtns.forEach((btn) => {
  btn.addEventListener('click', () => {
    window.changingSize = true;
    setTimeout(() => {
    window.changingSize = false;
    }, 600)
  })
})